/* * @Author: Wei Guojun * @Date: 2021-04-09 10:12:56 * @Last Modified by: Wei
Guojun * @Last Modified time: 2021-10-21 14:42:19 */
<template>
  <div class="login-new">
    <div class="show-window">
      <div class="title">
        <img src="../../assets/images/new_logo.png" alt="韵商宝" />
      </div>
      <div class="model">
        <div class="left">
          <img src="https://ysb.yundasys.com/file/downloadCenter?k=rkdyaxvqs&n=login-model.png" alt="韵商宝" />
        </div>
        <div class="right">
          <!--  -->
          <ul class="mytab">
            <li class="left-li" :class="[loginTab == 1 ? 'active' : '']" @click="handleTabClick('1')">
              <span>韵商宝用户</span>
            </li>
            <li class="right-li" :class="[loginTab == 2 ? 'active' : '']" @click="handleTabClick('2')">
              <span>快递员</span>
            </li>
          </ul>
          <!-- <el-tabs v-model="loginTab">
            <el-tab-pane label="微信登录" name="1"></el-tab-pane>
            <el-tab-pane label="快递员登录" name="2"></el-tab-pane>
          </el-tabs> -->
          <!-- <el-button size="mini" @click="loginTab = 2">快递员登录</el-button> -->
          <!-- 第二层tab -->
          <div class="tabway-list">
            <div 
              class="list-item"
              v-for="(item, index) in wayList"
              :key="item.wayType"
              @click="handleWayTabClick(item)"
            >
              <span :class="loginWay == item.wayType ? 'active-way' : ''">{{ item.wayName }}</span>
            </div>
          </div>
          <div>
            <div v-if="(loginTab == '2' && loginWay == '1') || (loginTab == '1' && loginWay == '3')">
              <signinCode ref="phoneForm" :loginTab="loginTab"/>
            </div>
            <!-- 1&1 二维码 -->
            <template v-if="loginTab == '1' && loginWay == '1'">
              <div class="reload" v-if="isExpire">
                <div class="reload_btn" @click="countdown">点击刷新</div>
                <div>二维码已失效，请刷新</div>
              </div>
              <div class="erweimaBox">
                <vueWxlogin
                  :appid="appid"
                  :scope="scope"
                  :redirect_uri="redirect_uri"
                  ref="erweima"
                  :href="'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7CiAgICB3aWR0aDogMjAxcHg7CiAgICBtYXJnaW4tdG9wOiAwcHgKfQouaW1wb3dlckJveCAudGl0bGUgewogZGlzcGxheTogbm9uZTsKfQouaW1wb3dlckJveCAuaW5mbyAuc3RhdHVzIHA6bGFzdC1jaGlsZHsKIGRpc3BsYXk6IG5vbmU7Cn0='"
                ></vueWxlogin>
              </div>
              <div v-if="!isExpire" class="timeint f-15">
                有效时间：<span>{{ time }}s</span>
              </div>
              <!-- <div v-else class="outtime f-15">
                <i class="el-icon-refresh-right"></i>请刷新重试
              </div> -->
            </template>
            <div v-if="loginWay == '2'">
              <signinAccount ref="phoneForm" :loginTab="loginTab" />
            </div>
            <!-- <div
              class="tabway"
              @click="loginWay == 1 ? (loginWay = 2) : (loginWay = 1)"
            >
              <span v-if="loginTab == '1' && loginWay == '1'"
                >账号密码登录</span
              >
              <span v-if="loginTab == '1' && loginWay == '2'"
                >微信扫码登录</span
              >
              <span v-if="loginTab == '2' && loginWay == '1'"
                >账号密码登录</span
              >
              <span v-if="loginTab == '2' && loginWay == '2'"
                >手机验证码登录</span
              >
            </div> -->
          </div>
          <div style="position: absolute; bottom: -23px" class="f-15">
            为更好的兼容打印控件，推荐使用<b>谷歌浏览器</b>
          </div>
        </div>
      </div>
    </div>

    <footer>
      <div>
        Copyright ©上海铿杰科技有限公司 KENGJIE Software Co.,Ltd. All rights
        reserved.
      </div>
    </footer>
    <div @click="goexcelBill" class="excelBottom">对账单临时方案</div>
  </div>
</template>
<script>
import vueWxlogin from "./components/vueWxlogin.vue";
import signinCode from "./components/signinCode.vue";
import signinAccount from "./components/signinAccount.vue";
import home from "@/api/home";
import util from "@/util/util";
export default {
  name: "",
  data() {
    return {
      // link: "",
      time: 180,
      timer: null,
      isExpire: false,
      expire_time: null,
      isLoading: false,
      appid: "",
      scope: "snsapi_login",
      redirect_uri: "",
      loginTab: "1", //1商家登录,2快递员登录
      loginWay: "1", //1原登录,2账号登录,
      urlconfig:null,
      ysbWayList: [{
        wayName: '微信扫码登录',
        wayType: '1',
      }, {
        wayName: '账号密码登录',
        wayType: '2',
      }, {
        wayName: '手机验证码登录',
        wayType: '3',
      }],
      courierWayList: [{
        wayName: '手机验证码登录',
        wayType: '1',
      }, {
        wayName: '账号密码登录',
        wayType: '2',
      }], 
    };
  },
  computed: {
    //计算属性
    wayList() {
      return this.loginTab == '1' ? this.ysbWayList : this.courierWayList
    },
  },
  created() {
    this.wxscanurl()
  },

  mounted: function () {
    this.getcommondata()
    this.countdown();
    this.$WebSocketClass.close();
  },
  destroyed() {
    clearInterval(this.timer);
    clearInterval(this.expire_time);
  },

  methods: {
    wxscanurl(){
      let hostname = window.location.hostname;
      if (hostname == "ybxsjb.yundasys.com") {
        // 生产环境
        this.appid = "wx4b9e983891247d8a";
        this.redirect_uri = window.location.origin + '/loading'
      } else if (hostname == "ysb.yundasys.com") {
        // 生产环境
        this.appid = "wxf1b26dc7843049cf";
        this.redirect_uri = window.location.origin + '/loading'
      } else if(hostname == "kdyduat.jxnq.net"){
        // 开发环境
        this.appid = "wxe3d91dc2b2f5007f";
        this.redirect_uri = window.location.origin + '/loading'
      }else {
        // 测试环境
        this.appid = "wxe3d91dc2b2f5007f";
        this.redirect_uri = 'https://kdyduat.jxnq.net/loading'
      }

    },
    getcommondata() {
      home.commondict(this).then((res) => {
        if (res.success) {
          this.$store.commit("SET_COMMON_DICT", JSON.stringify(res.data));
          let urlArr = res.data.data.filter(el => el.name =='pcUrlconfig')
          if(urlArr.length > 0){
            this.urlconfig = JSON.parse(urlArr[0].value)
          } 
        }
      })
    },
    goexcelBill() {
      window.open(this.urlconfig.statementUrl);
      // window.open('../../../logistics.html')
    },
    /** 失效倒计时 */
    countdown() {
      this.isExpire = false;
      this.time = 180;
      this.expire_time = setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          this.isExpire = true;
          clearInterval(this.expire_time);
          clearInterval(this.timer);
        }
      }, 1000);
    },
    // tabClick
    handleTabClick(tabType) {
      this.loginTab = tabType
      this.loginWay = '1'
    },
    // wayTab
    handleWayTabClick(item) {
      this.loginWay = item.wayType
    },
  },
  components: {
    vueWxlogin,
    signinCode,
    signinAccount,
  },
};
</script>

<style lang="stylus" scoped>
.excelBottom{
  position: absolute;
  bottom: 10px;
  right: 30px;
  z-index: 99;
  color: #fff;
  text-decoration: underline;
  cursor: pointer;
}
@keyframes am-show-login {
  from {
    right: -999px;
    opacity: 0;
  }

  to {
    right: 0;
    opacity: 0.95;
  }
}

.login-new {
  background-image: url('https://ysb.yundasys.com/file/downloadCenter?k=rkdyaxvqs&n=login-bg.png');
  // background-size: 100% 100%;
  background-size: cover;
  background-repeat: no-repeat;
  height: 100%;
  position: relative;
  // min-height: 900px;

  .show-window {
    width: 1200px;
    height: 633px;
    top: 90px;
    left: 50%;
    margin-left: -600px;
    bottom: 70px;
    position: absolute;

    .title {
      img {
        height: 99px;
      }
    }

    .model {
    //   background: #fff;
      height: 500px;
      border-radius: 10px;
      // margin-top: 20px;

      >div {
        float: left;
        height: 100%;
      }

      .left {
        width: 664px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 544px;
          height: 474px;
        }
      }
      .mytab{
        width :100%;
        line-height: 3.375;
        text-align: center;
        // margin-top: 10px;
        background: #F5F5F5;
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
        li{
          // width :30%;
          width: 50%;
          background: #F5F5F5;
          display: inline-block;
          cursor: pointer;
          color: #444444;
          font-size: 16px;
          font-weight: 400;
          font-family: "PingFang SC";
          &.active{
            // color: #1B72E9;
            color: #222222;
            background: #FFF;
            font-weight: 500;
            >span{
              // border-bottom:2px solid #1B72E9;
            }
          }
        }
        .left-li {
          border-top-left-radius: 16px;
          // border-bottom-right-radius: 16px;
          // border-radius: 16px 0 16px 0;
        }

        .right-li {
          border-top-right-radius: 16px;
          // border-bottom-left-radius: 16px;
          // border-radius: 0 16px 0 16px;
        }
      }
      // 第二层tab
      .tabway-list {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        font-family: "PingFang SC";
        color: #999;
        box-sizing: border-box;
        width: 100%;
        .list-item {
          padding: 16px 0;
          flex: 1;
          text-align: center;
          >span{
            padding-bottom: 5px;
          }
        }
      }
      .active-way {
        color: #222222;
        font-weight: 500;
        border-bottom:2px solid #409EF2;
      }

      // .tabway{
      //   float: right ;
      //   color: #2ea2fc;
      //   font-size: 13px;
      //   cursor: pointer;
      // }
      .erweimaBox{
        // height: 356px;
        // height: 255px;
        height: 250px;
        overflow: hidden;
      }
      .right {
        display: flex;
        flex-direction: column;
        align-items: center;
        // justify-content: center;
        background #FFF
        // width: 500px;
        // width: 385px;
        // height: 415px;
        border-radius 16px
        position relative;
        // 修改
        width: 440px;
        // height: 415px;
        // height: 372px;
        height: 424px; 

        h3{
          color #409EFF;
        }
        .reload{
          width: 253px;
          height: 203px;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          // top: 74px;
          top: 100px;
          background: red;
          background: rgba(255,255,255,.8);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-size :15px;
          // color #fff
          .reload_btn{
            background  #2ea2fc;
            width 140px;
            height 40px;
            line-height 40px;
            text-align center;
            color #fff
            border-radius: 4px
            margin:32px 0 52px;
            font-size:16px;
            cursor: pointer;
          }
        }
        .f-15{
          font-size: 15px
        }
        .timeint span{
          color #67C23A;
        }
        .outtime{
          color #2ea2fc;
        }
        .header-title {
          display: flex;
          flex-direction: row;
          width: 100%;
          align-items: center;

          span {
            height: 50px;
            width: 50%;
            text-align: center;
            font-size: 16px;
          }
        }

        .qrcode {
          width: 200px;
          height: 200px;
          background: #f5f5f5;
          margin: 62px 0 26px 0;
          position: relative;

          .invalid {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.7);
            text-align: center;
            z-index: 9;

            .c-title {
              color: #ffffff;
              font-size: 20px;
              text-align: center;
              margin-top: 50%;
              transform: translate(0, -50%);
              margin-bottom: 10px;
            }

            .btn {
              background: #1C8BF6;
              color: #ffffff;
              border-radius: 4px;
              padding: 10px 18px;
            }
          }

          #qrcode {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 1;
          }

          .netVaild {
            height: 180px;

            p {
              padding: 20px;
              font-size: 14px;
              text-align: left;
              color: #FF8C00;
            }

            /deep/.el-button {
              margin-left: 26px;
              background: #FFD700;
              border-color: #FFD700;
              color: #000;
            }
          }
        }

        .tips {
          font-size: 14px;
          font-weight: 400;
          color: rgba(115, 115, 115, 1);
          line-height: 25px;

          img {
            width: 25px;
            height: 25px;
            margin-right: 10px;
          }
        }
      }
    }
  }

  footer {
    text-align: center;
    font-size: 24px;
    color: #ffffff;
    font-weight: 400;
    width: 100%;
    font-size: 18px;
    height: 70px;
    position: absolute;
    bottom: 40px;

    >div {
      position: absolute;
      bottom: 20px;
      width: 100%;
    }
  }
}

@media screen and (min-height: 1080px) {
  .login-new {
    .show-window {
      height: 733px;

      .model {
        height: 636px;
      }
    }
  }
}

@media screen and (max-height: 900px) {
  .login-new {
    height: 100vh;
    min-height: 683px;
    min-width: 1120px;
    footer{
      font-size: 16px;
    }
    .show-window {
      width: 1000px;
      height: 433px;
      top: 80px;
      margin-left: -450px;
      bottom: 70px;
      .title img{
        height: 80px;
      }
      .model {
        height: 500px;
        display: flex;
        justify-content: space-between;
        >div {
          float: left;
          height: 100%;
        }
        .right{
          // width: 385px;
          // height: 385px;
          width: 440px;
          // height: 385px;
          height: 400px;
          // height: 372px;
        } 
        .left {
          width: 460px;

          img {
            width: 385px;
            height: 310px;
          }
        }
      }
    }
  }
}
@media screen and (max-height: 680px) {
  .login-new {
    height: 100vh;
    min-height: 600px;
    min-width: 1000px;
    footer{
      font-size: 14px;
    }
    .show-window {
      width: 1000px;
      height: 433px;
      top: 80px;
      margin-left: -450px;
      bottom: 70px;
      .erweimaBox{
        height: 238px !important;
        // height: 215px !important;
      }
      .title img{
        height: 70px;
      }
      .model {
        height: 500px;
        display: flex;
        justify-content: space-between;
        >div {
          float: left;
          height: 100%;
        }
        .right{
          width: 360px;
          // height: 360px;
          // height: 304px;
          height: 370px;
        } 
        .left {
          width: 360px;

          img {
            width: 320px;
            height: 300px;
          }
        }
      }
    }
  }
}
</style>
